import type { ConsentChoice } from '@nt/consent'

import { SettingSwitchRow } from '@/components/molecules/shared/setting-switch-row'

/**
 * The cookie purposes as rows: Necessary (always on), then the Analytics and
 * Advertising switches. The banner's Customize view and Settings › Cookies
 * both render these, so the two never describe different choices.
 */
export function ConsentPurposeRows({
  id,
  draft,
  onChange,
}: {
  id: string
  draft: ConsentChoice
  onChange: (next: Partial<ConsentChoice>) => void
}) {
  return (
    <>
      <div className="flex items-start justify-between gap-4 py-3">
        <div>
          <p className="text-sm font-medium text-foreground">Necessary</p>
          <p className="text-sm text-muted-foreground">Keep the site working and your account secure.</p>
        </div>
        <p className="shrink-0 text-sm text-muted-foreground">Always on</p>
      </div>
      <SettingSwitchRow
        id={`${id}-analytics`}
        label="Analytics"
        description="Show us which pages people use, so we can improve them."
        checked={draft.analytics}
        onCheckedChange={(analytics) => onChange({ analytics })}
      />
      <SettingSwitchRow
        id={`${id}-advertising`}
        label="Advertising"
        description="Measure our ads and show them to people who may need us."
        checked={draft.advertising}
        onCheckedChange={(advertising) => onChange({ advertising })}
      />
    </>
  )
}
